import React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"


// What to do first on a page that shows nothing yet ("Apply filters and search"): the same tinted icon
// tile, title and muted line on every page, at the same height under the filters
export default function AppStartHint({ icon = 'magnifying-glass', title, description, sx = {} }) {
	return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', gap: 1.25, py: 10, ...sx }}>
		<Box sx={{
			width: 48, height: 48, mb: 0.5, borderRadius: '12px',
			display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
			backgroundColor: dsColorNew.pillActiveBg, color: dsColorNew.appBlue,
		}}>
			<IconSeeker icon={icon} sx={{ fontSize: 20 }}/>
		</Box>
		<Typography sx={{ fontSize: 16, fontWeight: 600, color: dsColorNew.textTitle, maxWidth: 520 }}>
			{title}
		</Typography>
		{!!description && <Typography sx={{ fontSize: 13, color: dsColorNew.textMuted, maxWidth: 440, lineHeight: 1.45 }}>
			{description}
		</Typography>}
	</Box>
}

// Shown under a filter band until the first search.
export const searchStartHintProps = {
	title: 'Apply filters and search',
	description: 'Choose your filters above and click Search to see the results',
}
